import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page75() {
  useEffect(() => {
    document.title = "Маяк — Страница 74"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page73" />
        <ForwardLink href="/page75" />
      </div>

      <p style={{ textAlign: "right" }}>74.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Вот еще.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я...<br/>
        <br/>
        Слушайте...<br/>
        <br/>
        Я не могу, не могу.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Тогда заткни пасть.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я могу доверять Вам.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Нет.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я доверяю Вам, Том.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Доверяешь мне?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Нет. Я Вам совсем не доверяю.
      </p>
      <p>Они смеются. Выпивают.</p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КУБРИК – ПОЗЖЕ ТОЙ ЖЕ НОЧЬЮ</p>
      <p>
        ЧАСЫ монотонно тикают. Каким-то образом<br/>
        звуки грозы стали тише. Звуки дождя также постепенно исчезают.
      </p>
      <p>БЛИЗКО: МОЛОДОЙ смотрит дикими глазами. Совершенно неподвижно.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        И он был у меня под рукой и беспомощен.<br/>
        Один. Слишком далеко вниз по течению. И я<br/>
        хотел его прикончить. Я признаю.<br/>
        Вижу его затылок. Один<br/>
        взмах крюком, и все. Это<br/>
        было... Я не... но я не...<br/>
        я не сделал это. День на этом сплаве был<br/>
        чертовски длинным. Я очень устал. Я<br/>
        признаю это. Но я видел, как он подскользнулся,<br/>
        не я. И мы видели, что приближается затор из бревен.<br/>
        И я стоял, а он подскользнулся. Он<br/>
        стал кричать. А я просто стоял. “Том,<br/>
        ты пес!”. А я стоял, вот и все. Просто<br/>
        стоял и смотрел, как его поглощают<br/>
        бревна.<br/>
        (ДАЛЕЕ)
      </p>
      <p style={{ textAlign: "right" }}>74.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page73" />
        <ForwardLink href="/page75" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710634223/the-lighthouse-script/up3wlw90f5syzhn0fgbm.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page75;
